<template>
    <form
        @submit.prevent="requestResetPasswordEmail"
        :action="urls.forgot_password"
        method="POST"
        class="p-4 bg-white rounded shadow"
    >
        <div class="space-y-4">
            <h1 class="text-3xl tracking-wide font-bold py-4 text-center text-gray-800">Forgot Password</h1>

            <div class="mx-auto w-16 border-b-2 border-gray-300"></div>

            <div class="p-4 bg-gray-200 rounded text-sm text-gray-700">
                Forgot your password? No problem. Just let us know your email address and we will email you a password reset link that will allow you to choose a new one.
            </div>

            <text-input
                v-model="form.email"
                label="Email"
                name="email"
                type="text"
                autofocus
                placeholder="paul.bunyan@example.com"
                :error="form.errors.email"
            />

            <div class="flex flex-col">
                <loading-button
                    :loading="form.processing"
                    type="submit"
                    class="btn btn-green"
                >
                    Email Password Reset Link
                </loading-button>

            </div>
        </div>
    </form>
</template>

<script>
import Form from '@/functions/Form'
import TextInput from "./shared/TextInput"
import LoadingButton from './shared/LoadingButton'
import emitter from 'tiny-emitter/instance'

export default {
    props: {
        urls: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            form: Form({
                email: ''
            })
        }
    },
    methods: {
        requestResetPasswordEmail() {
            this.form.post(this.urls.forgot_password, {
                onSuccess: ({ notification }) => {
                    this.form.reset()
                    this.$store.commit('setNotification', notification)
                },
            })
        }
    },
    components: {
        TextInput,
        LoadingButton,
    },
}
</script>
